<template>
  <form @submit.prevent="updateDevice">
    <md-card>
      <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>phone</md-icon>
        </div>
        <h4 class="title">
          Registrar Dispositivo
        </h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Proyecto
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <multiselect
                  v-model="projectValue"
                  :options="projects"
                  track-by="name"
                  label="name"
                  :allow-empty="false"
                  :searchable="true"
                  placeholder="Seleccione un Projecto">
              </multiselect>
              <validation-error :errors="apiValidationErrors.projectValue"/>
            </md-field>
          </div>
        </div>

      </md-card-content>

      <md-card-content>
        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Tipo de Línea
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <multiselect
                  v-model="typeLineValue"
                  :options="typeLines"
                  track-by="name"
                  label="name"
                  :allow-empty="false"
                  :searchable="true"
                  placeholder="Seleccione un Tipo de Línea">
              </multiselect>
              <validation-error :errors="apiValidationErrors.typeLineValue"/>
            </md-field>
          </div>
        </div>

      </md-card-content>

      <md-card-content>
        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Teléfono
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <md-input v-model="device.phone"/>
              <validation-error :errors="apiValidationErrors.phone"/>
            </md-field>
          </div>
        </div>

      </md-card-content>

      <md-card-actions>
        <md-button type="submit">
          Actualizar Dispositivo
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import {get} from "lodash";

export default {
  name: "DeviceEditCard",
  props: {
    device: Object,
  },
  components: {ValidationError, Multiselect},
  mixins: [formMixin],
  data() {
    return {
      projects: [],
      projectValue: null,
      typeLines: [],
      typeLineValue: null,
    };
  },
  async created() {
    await this.getProjects();
    await this.getTypeLines();
    await this.defaultValueProject();
    await this.defaultValueTypeLine();
  },
  methods: {
    async getProjects() {
      try {
        await this.$store.dispatch("projects/list");

        this.projects = await this.$store.getters["projects/list"]

      } catch (e) {
        let message = get(e.response.data.errors[0], 'detail');
        await this.$store.dispatch("alerts/error", `Oops, ${message}`);

        this.setApiValidation(e.response.data.errors)
      }
    },
    async getTypeLines() {
      try {
        await this.$store.dispatch("typeLines/list");

        this.typeLines = await this.$store.getters["typeLines/list"]

      } catch (e) {
        let message = get(e.response.data.errors[0], 'detail');
        await this.$store.dispatch("alerts/error", `Oops, ${message}`);

        this.setApiValidation(e.response.data.errors);
      }
    },
    async defaultValueProject() {
      try {
        this.projectValue = this.projects.find(project => project.id === this.device.project_id);
      } catch (e) {
        let message = get(e.response.data.errors[0], 'detail');
        await this.$store.dispatch("alerts/error", `Oops, ${message}`);

        this.setApiValidation(e.response.data.errors);
      }
    },
    async defaultValueTypeLine() {
      try {
        this.typeLineValue = this.typeLines.find(typeLine => typeLine.id === this.device.type_line_id);
      } catch (e) {
        let message = get(e.response.data.errors[0], 'detail');
        await this.$store.dispatch("alerts/error", `Oops, ${message}`);

        this.setApiValidation(e.response.data.errors);
      }
    },
    async updateDevice() {
      try {
        await this.$store.dispatch("devices/update", {...this.device, project_id: this.projectValue.id, type_line_id: this.typeLineValue.id});
        await this.$store.dispatch(
            "alerts/success",
            "El Dispositivo se ha Actualizado Satisfactoriamente."
        );

        await this.$router.push({name: 'List Devices'})

      } catch (e) {
        let message = get(e.response.data.errors[0], 'detail');
        await this.$store.dispatch(
            "alerts/error",
            `Oops..${message}`
        );

        this.setApiValidation(e.response.data.errors);
      }
    },
  }
}
</script>
